import React from "react";
import { Dropdown } from "antd";
import { DashboardOutlined, FileTextOutlined, LogoutOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {performLogout} from "../../utils/auth";

const UserMenu = () => {
    const navigate = useNavigate();
    // const { isAuthenticated } = useSelector((state) => state.auth || {});

    const isAuthenticated = !!localStorage.getItem("token")

    const tenantUser = useSelector((state) => state.tenantUser.tenantUser);
    const tenant = useSelector((state) => state.tenant.company);
    const dispatch = useDispatch();

    if (!isAuthenticated) return null;

    const items = [
        {
            key: "user-info",
            label: (
                <div style={{ padding: 10 }}>
                    <strong>{tenantUser?.email}</strong>
                    <br />

                    <span style={{
                        background: "#E8F5E9",
                        padding: "2px 8px",
                        borderRadius: 10,
                        fontSize: 12,
                        color: "#28C76F",
                        display: "inline-block",
                        marginTop: 5
                    }}>
            {tenant?.plan || "Business"}
          </span>
                </div>
            ),
            disabled: true,
        },
        { type: "divider" },
        {
            key: "dashboard",
            icon: <DashboardOutlined />,
            label: "Mon espace",
            onClick: () => {
                navigate("/account");
            },
        },
        {
            key: "documents",
            icon: <FileTextOutlined />,
            label: "Mes documents",
            onClick: () => {
                navigate("/account/documents");
            },
        },
        {
            key: "logout",
            icon: <LogoutOutlined />,
            label: "Déconnexion",
            onClick: () => {
                performLogout(dispatch, navigate);
                navigate("/");
            },
        },
    ];

    return (
        <Dropdown menu={{ items }} trigger={["click"]}>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                cursor: "pointer"
            }}>
                {/* Avatar */}
                {/*<Avatar size={40} icon={<UserOutlined />} />*/}
                <img
                    src="images/icon-images/account.png"
                    height='50'
                    width='50'
                    className="img-fluid rounded-3"
                    alt="account"
                />

                {/* Nom + plan visible */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "#1e4b8a" }}>
            bienvenu,
          </span>
          <span style={{ fontWeight: 600, color: "#1e4b8a" }}>
              {tenantUser?.fullName}
          </span>

                    <span style={{
                        fontSize: 11,
                        background: "#E8F5E9",
                        padding: "2px 6px",
                        borderRadius: 8,
                        color: "#28C76F",
                        width: "fit-content"
                    }}>
            {tenant?.plan}
          </span>
                </div>
            </div>
        </Dropdown>
    );
};

export default UserMenu;